import { render, staticRenderFns } from "./jiajuDialog.vue?vue&type=template&id=1849c366&scoped=true"
import script from "./jiajuDialog.vue?vue&type=script&lang=js"
export * from "./jiajuDialog.vue?vue&type=script&lang=js"
import style0 from "./jiajuDialog.vue?vue&type=style&index=0&id=1849c366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1849c366",
  null
  
)

export default component.exports